import { callApi } from "./fetchTools";
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from "../utils/constant";
import apis from "../common/apis";
import { IResponse } from "./../models/base";
import { HTTP_METHOD_PUT } from "./../utils/constant";
import IShippingInfo from "../models/shippingInfoModel";
import _ from 'lodash'

const updateShippingDeliveryInfo = (id: string, info: IShippingInfo) => {
  let data = _.clone<any>(info);
  delete data._id;
  delete data.address;
  data.province = info.address?.province;
  data.country = info.address?.country;
  data.district = info.address?.district;
  data.full_address = info.address?.full_address;
  data.street = info.address?.street;
  data.ward = info.address?.ward;
  return callApi<IShippingInfo>(HTTP_METHOD_PUT, `${apis.user_delivery}${id}`, data);
}


const createShippingDeliveryInfo = (info: any) => {
  let data = _.clone<any>(info);
  delete data._id;
  delete data.address;
  data.province = info.address?.province;
  data.country = info.address?.country;
  data.district = info.address?.district;
  data.full_address = info.address?.full_address;
  data.street = info.address?.street;
  data.ward = info.address?.ward;
  return callApi<IShippingInfo>(HTTP_METHOD_POST, `${apis.user_delivery}`, data);
}

export default {
  createShippingDeliveryInfo: createShippingDeliveryInfo,
  updateShippingDeliveryInfo: updateShippingDeliveryInfo,
  profileGetInfo: () => {
    return callApi<any>(HTTP_METHOD_GET, apis.user_profile, null);
  },
  profileUpdateInfo: (query: any) => {
    return callApi<IResponse<any>>(
      HTTP_METHOD_PUT,
      apis.user_update_profile,
      query
    );
  },
  profileChangePassword: (query: any) => {
    return callApi<IResponse<any>>(
      HTTP_METHOD_PUT,
      apis.user_change_password,
      query
    );
  },
  getPointHistories: (query: any) => {
    return callApi<IResponse<any>>(
      HTTP_METHOD_GET,
      apis.user_point_history,
      query
    );
  },
};
